// extracted by mini-css-extract-plugin
export var addressCarouselContainer = "detailsAddress-module--address-carousel-container--b7043";
export var addressContact = "detailsAddress-module--address-contact--857cc";
export var addressContentFooter = "detailsAddress-module--address-content-footer--d10fe";
export var addressContentFooterBack = "detailsAddress-module--address-content-footer-back--dd474";
export var addressMail = "detailsAddress-module--address-mail--6f61a";
export var addressPlace = "detailsAddress-module--address-place--044e4";
export var addressTel = "detailsAddress-module--address-tel--39daf";
export var addressTitle = "detailsAddress-module--address-title--8f290";
export var editButton = "detailsAddress-module--edit-button--77372";
export var gridAddress = "detailsAddress-module--grid-address--4d225";
export var gridAriane = "detailsAddress-module--grid-ariane--716f3";
export var gridContent = "detailsAddress-module--grid-content--32514";
export var gridResume = "detailsAddress-module--grid-resume--50754";
export var gridTitle = "detailsAddress-module--grid-title--35610";
export var pageAddress = "detailsAddress-module--page-address--0f521";
export var pageAddressAdditionalInfos = "detailsAddress-module--page-address-additional-infos--0bda1";